import React from 'react';

const BurgerLink = ({to, selected = false, current = "/app", onClick, ...props}) => {
    const handleClick = () => {
        if(onClick) {
            onClick();
            return;
        }
        if (to || to === "") {
            window.location.href = process.env.REACT_APP_WEBSITE_DOMAIN + to;
        }
    }

    return (
        <div
            className={`cursor-pointer text-gray-400 border-b last:border-none py-2 ${current === to ? "font-bold" : ""}`}
            onClick={handleClick}>
            {props.children}
        </div>
    );
}

export default BurgerLink;